"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _secKill = require("@/api/activity/secKill");
var _bonusSend = require("@/api/activity/bonusSend");
var _lottery = require("@/api/activity/lottery");
var _gradeInfo = require("@/api/basic/gradeInfo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 自定义图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fileList: [],
      uploading: false
    };
  },
  watch: {
    value: function value(val) {
      if (val && !this.fileList.length) {
        this.fileList = [{
          name: 'image',
          url: this.getDisplayUrl(val)
        }];
      } else if (!val) {
        this.fileList = [];
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.fileList = [{
        name: 'image',
        url: this.getDisplayUrl(this.value)
      }];
    }
  },
  methods: {
    // 从 VUE_APP_IMAGE_PATH 中提取路径前缀，例如 'https://opstest.gagacafe.com/images/mall' → '/images/mall'
    extractPathPrefix: function extractPathPrefix() {
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return '';
      try {
        if (prefix.startsWith('http://') || prefix.startsWith('https://')) {
          return new URL(prefix).pathname;
        }
      } catch (e) {}
      return prefix;
    },
    // 将存储的相对文件名拼接为完整URL用于展示
    getDisplayUrl: function getDisplayUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, relativePath, urlObj, matches, pathPrefix, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _secKill.uploadSecKillImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              // 兼容不同的返回格式：res.data 或者直接 res
              url = res && res.data || res;
              if (url) {
                // 转换为相对路径（与抽奖活动保持一致：后端只存相对文件名，前端拼接前缀）
                relativePath = url;
                if (url.startsWith('http://') || url.startsWith('https://')) {
                  try {
                    urlObj = new URL(url);
                    relativePath = urlObj.pathname;
                  } catch (e) {
                    // 如果 URL 解析失败，尝试手动提取路径
                    matches = url.match(/https?:\/\/[^/]+(.+)/);
                    if (matches && matches[1]) {
                      relativePath = matches[1];
                    }
                  }
                }

                // 剥离路径前缀（如 /images/mall），仅保留文件名部分
                pathPrefix = this.extractPathPrefix();
                if (pathPrefix && relativePath.indexOf(pathPrefix) === 0) {
                  relativePath = relativePath.substring(pathPrefix.length);
                }
                // 统一去掉开头的斜杠，存储为纯文件名（如 xxx.jpg）
                relativePath = relativePath.replace(/^\/+/, '');
                this.fileList = [{
                  name: file.name,
                  url: this.getDisplayUrl(relativePath)
                }];
                this.$emit('input', relativePath);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.fileList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
              this.fileList = [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.$emit('input', '');
    },
    handlePreview: function handlePreview() {
      if (this.fileList.length > 0) {
        window.open(this.fileList[0].url, '_blank');
      }
    }
  },
  render: function render(h) {
    var _this = this;
    var hasFile = this.fileList.length > 0;
    if (hasFile && !this.disabled) {
      return h('div', {
        class: 'image-upload-container',
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '100px',
          height: '100px'
        }
      }, [
      // 图片预览
      h('img', {
        attrs: {
          src: this.fileList[0].url
        },
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '6px',
          border: '1px solid #dcdfe6'
        },
        on: {
          click: this.handlePreview
        }
      }),
      // 删除按钮
      h('i', {
        class: 'el-icon-close',
        style: {
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#909399',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '12px',
          zIndex: 1
        },
        on: {
          click: this.handleRemove
        }
      })]);
    } else {
      // 上传按钮
      var uploadButton = h('el-upload', {
        class: 'image-uploader',
        props: {
          'show-file-list': false,
          'before-upload': this.beforeUpload,
          'http-request': function httpRequest(options) {
            _this.uploadImage(options.file);
          },
          disabled: this.disabled
        }
      }, [h('div', {
        class: 'el-upload el-upload--text',
        style: {
          width: '100px',
          height: '100px',
          border: '1px dashed #d9d9d9',
          borderRadius: '6px',
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fbfdff'
        }
      }, [h('i', {
        class: 'el-icon-plus',
        style: {
          fontSize: '28px',
          color: '#8c939d'
        }
      })])]);
      return h('div', {
        class: 'image-upload-container',
        style: {
          display: 'inline-block'
        }
      }, [uploadButton]);
    }
  }
};
var _default = exports.default = {
  name: 'SecKillConfigPane',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      timeRange: [],
      userRankChecked: [],
      userRankOptions: [],
      couponPackagesList: [],
      selectedPackageId: null,
      couponPackagesLoaded: false,
      bonusList: [],
      bonusListLoaded: false,
      selectedCouponId: null,
      originalTotalNum: null,
      // 原始库存数，用于编辑时比较
      itemSpecialUnitPrices: {},
      // 各券明细的特惠单价（手动编辑），key: item.id, value: 单价
      form: {
        title: '',
        subTitle: '',
        tag: '',
        mode: 1,
        userType: 0,
        userRank: '',
        isQwe: 0,
        type: 4,
        sid: null,
        marketMoney: 0,
        money: 0,
        specialMoney: 0,
        totalNum: 0,
        prePeopleNum: 0,
        startTime: null,
        endTime: null,
        imgUrl: '',
        coverImgUrl: '',
        introImgUrl: '',
        canShare: true,
        shareTitle: '',
        shareImgUrl: '',
        enabled: 1,
        notice: '',
        todayreg: 0,
        jioncoupon: 0,
        userorder: 0,
        expired: 0
      },
      rules: {
        title: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        tag: [{
          required: true,
          message: '请输入标签',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择购买类型',
          trigger: 'change'
        }],
        marketMoney: [{
          validator: this.validateMarketMoney,
          trigger: 'blur'
        }],
        money: [{
          validator: this.validateMoney,
          trigger: 'blur'
        }],
        totalNum: [{
          required: true,
          message: '请输入库存数',
          trigger: 'blur'
        }],
        prePeopleNum: [{
          required: true,
          message: '请输入每人限购数量',
          trigger: 'blur'
        }],
        imgUrl: [{
          required: true,
          message: '请上传封面图',
          trigger: 'change'
        }],
        coverImgUrl: [{
          required: true,
          message: '请上传列表图',
          trigger: 'change'
        }],
        introImgUrl: [{
          required: true,
          message: '请上传简介图',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    selectedPackage: function selectedPackage() {
      var _this2 = this;
      if (!this.selectedPackageId) return null;
      return this.couponPackagesList.find(function (pkg) {
        return pkg.id === _this2.selectedPackageId;
      }) || null;
    },
    selectedCoupon: function selectedCoupon() {
      var _this3 = this;
      if (!this.selectedCouponId) return null;
      return this.bonusList.find(function (bonus) {
        return bonus.typeId === _this3.selectedCouponId;
      }) || null;
    },
    isAllItemsSelected: function isAllItemsSelected() {
      if (!this.selectedPackage || !this.selectedPackage.items) return false;
      return this.selectedPackage.items.every(function (item) {
        return item.checked;
      });
    },
    isAllUserRanksSelected: function isAllUserRanksSelected() {
      var _this4 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.length > 0 && this.userRankOptions.every(function (rank) {
        return _this4.userRankChecked.includes(rank.id);
      });
    },
    isEdit: function isEdit() {
      return !!this.id;
    },
    // 是否满足特惠价格条件
    specialPriceConditionMet: function specialPriceConditionMet() {
      return !!(this.form.todayreg || this.form.jioncoupon || this.form.userorder);
    },
    // 获取选中的券明细
    checkedItems: function checkedItems() {
      if (!this.selectedPackage || !this.selectedPackage.items) return [];
      return this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
    },
    // 各券明细的购买价（通过券包rateType计算，总和等于券包price）
    // rateType=1(比例)：按rateNum比例分配券包购买价，尾差在最后一项
    // rateType=2(金额)：直接使用rateNum
    // 无购买价时展示原价(面额)
    itemPurchasePrices: function itemPurchasePrices() {
      var result = {};
      if (!this.selectedPackage || !this.selectedPackage.items) return result;
      var items = this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
      if (items.length === 0) return result;
      var rateType = parseInt(this.selectedPackage.rateType);
      var packagePrice = parseFloat(this.selectedPackage.price) || 0;
      if (rateType === 1 && packagePrice > 0) {
        // 比例：按rateNum分配券包购买价
        var totalRateNum = items.reduce(function (sum, item) {
          return sum + (parseFloat(item.rateNum) || 0);
        }, 0);
        if (totalRateNum > 0) {
          var accumulated = 0;
          items.forEach(function (item, index) {
            var rateNum = parseFloat(item.rateNum) || 0;
            if (index === items.length - 1) {
              // 尾差：确保总和等于券包购买价
              result[item.id] = Math.round((packagePrice - accumulated) * 100) / 100;
            } else {
              var price = packagePrice * rateNum / totalRateNum;
              var rounded = Math.round(price * 100) / 100;
              result[item.id] = rounded;
              accumulated += rounded;
            }
          });
          return result;
        }
      }
      if (rateType === 2) {
        // 金额：直接使用rateNum
        items.forEach(function (item) {
          var rateNum = parseFloat(item.rateNum) || 0;
          if (rateNum > 0) {
            result[item.id] = rateNum;
          } else {
            result[item.id] = parseFloat(item.oldPrice) || parseFloat(item.money) || 0;
          }
        });
        return result;
      }

      // 未知类型或无数据：展示原价(面额)
      items.forEach(function (item) {
        result[item.id] = parseFloat(item.money) || 0;
      });
      return result;
    },
    // 购买价合计：rateType=1 = 券包购买价；rateType=2 = Σ rateNum × sendNum
    totalPurchasePrice: function totalPurchasePrice() {
      if (!this.selectedPackage) return 0;
      var rateType = parseInt(this.selectedPackage.rateType);
      var items = this.checkedItems;
      if (rateType === 1) {
        return parseFloat(this.selectedPackage.price) || 0;
      }
      if (rateType === 2) {
        var total = 0;
        items.forEach(function (item) {
          var rateNum = parseFloat(item.rateNum) || 0;
          var qty = parseInt(item.sendNum) || 1;
          total += rateNum * qty;
        });
        return Math.round(total * 100) / 100;
      }
      // rateType 未知：回退旧逻辑（Σ 单价）
      var prices = this.itemPurchasePrices;
      return Object.keys(prices).reduce(function (sum, id) {
        return sum + prices[id];
      }, 0);
    },
    // 特惠价合计（由券明细特惠单价 × 发券数量之和计算）
    totalSpecialPrice: function totalSpecialPrice() {
      var _this5 = this;
      var total = 0;
      this.checkedItems.forEach(function (item) {
        var unitPrice = parseFloat(_this5.itemSpecialUnitPrices[item.id]) || 0;
        var qty = parseInt(item.sendNum) || 1;
        total += unitPrice * qty;
      });
      return Math.round(total * 100) / 100;
    },
    // 是否展示特惠价列（条件满足即展示，便于用户输入单价）
    showSpecialPriceColumn: function showSpecialPriceColumn() {
      return this.specialPriceConditionMet;
    }
  },
  watch: {
    selectedPackageId: function selectedPackageId(newVal) {
      var _this6 = this;
      if (!newVal) return;
      // 当券包选择变化时，延迟执行以确保 selectedPackage 已更新
      this.$nextTick(function () {
        if (_this6.selectedPackage && _this6.selectedPackage.items) {
          // 使用统一的处理逻辑
          _this6.handlePackageChange(newVal);
          // 编辑模式首次加载：根据已有的 specialMoney 初始化各券明细特惠单价
          if (_this6.id && _this6.form.type === 4 && !_this6._specialPricesInited) {
            _this6._specialPricesInited = true;
            // 优先使用已保存的明细价格，没有时才按比例重新分配
            if (_this6._loadedDetails && _this6._loadedDetails.length > 0) {
              var detailMap = {};
              _this6._loadedDetails.forEach(function (d) {
                detailMap[d.itemId] = d;
              });
              _this6.selectedPackage.items.forEach(function (item) {
                var d = detailMap[item.id];
                if (d) {
                  _this6.$set(_this6.itemSpecialUnitPrices, item.id, parseFloat(d.specialMoney) || 0);
                } else {
                  _this6.$set(_this6.itemSpecialUnitPrices, item.id, 0);
                }
              });
              _this6._loadedDetails = null;
            } else {
              _this6.redistributeSpecialUnitPrices();
            }
          }
        }
      });
    },
    userRankChecked: function userRankChecked(val) {
      this.form.userRank = (0, _toConsumableArray2.default)(val).sort().join(',');
    },
    'form.userType': function formUserType(newVal) {
      // 当选择新用户时，清空用户级别选择
      if (newVal === 1) {
        this.userRankChecked = [];
      } else if (!this.userRankChecked || this.userRankChecked.length === 0) {
        // 切换到非新用户时，默认全选所有用户级别
        this.userRankChecked = this.userRankOptions.map(function (rank) {
          return rank.id;
        });
      }
    },
    'form.type': function formType(newVal) {
      var _this7 = this;
      // 当购买类型变化时，清空选择并重新处理
      // 只在新建模式（没有 id）时才清空价格
      if (!this.id) {
        this.form.marketMoney = 0;
        this.form.money = 0;
      }
      if (newVal === 4) {
        // 切换到套券：清空优惠券选择
        this.selectedCouponId = null;
        // 如果有券包选择，重新处理券包
        if (this.selectedPackage && this.selectedPackage.items) {
          this.selectedPackage.items.forEach(function (item) {
            _this7.$set(item, 'checked', true);
            _this7.$set(item, 'disabled', true);
          });
          // 套券：自动填充价格（只在新建时）
          if (!this.id) {
            if (this.selectedPackage.oldPrice != null) {
              this.form.marketMoney = this.selectedPackage.oldPrice;
            }
            if (this.selectedPackage.price != null) {
              this.form.money = this.selectedPackage.price;
            }
          }
        }
      } else {
        // 切换到单品券：清空券包选择
        this.selectedPackageId = null;
      }
    },
    // 不满足特惠金额条件时，特惠金额清零；满足时套券模式由明细单价计算
    specialPriceConditionMet: function specialPriceConditionMet(val) {
      if (!val) {
        this.form.specialMoney = 0;
      } else if (this.form.type === 4) {
        // 套券模式：由明细特惠单价计算
        this.form.specialMoney = this.totalSpecialPrice;
      }
      // 单品券模式：保留手动输入，不清空
    },
    // 特惠总价变动时同步到 form.specialMoney（仅套券模式由明细单价驱动）
    totalSpecialPrice: function totalSpecialPrice(newVal) {
      if (this._isRedistributing) return;
      if (this.specialPriceConditionMet && this.form.type === 4) {
        this.form.specialMoney = newVal;
      }
    }
  },
  created: function created() {
    this._isRedistributing = false;
    this.loadUserRankOptions();
    this.loadCouponPackages();
    this.loadBonusList();
    if (this.id) {
      this.fetchDetail();
    }
  },
  methods: {
    fetchDetail: function fetchDetail() {
      var _this8 = this;
      this.loading = true;
      (0, _secKill.getSecKillDetail)(this.id).then(function (response) {
        var data = response.data;

        // 保存券明细价格列表，供券包加载完成后使用
        _this8._loadedDetails = data.details || [];
        Object.keys(_this8.form).forEach(function (key) {
          if (data[key] !== undefined) {
            _this8.form[key] = data[key];
          }
        });

        // 保存原始库存数，用于编辑时验证
        _this8.originalTotalNum = data.totalNum;

        // 处理时间范围
        if (data.startTime && data.endTime) {
          _this8.timeRange = [data.startTime, data.endTime];
        }

        // 处理用户级别
        if (data.userRank) {
          _this8.userRankChecked = data.userRank.split(',').map(Number);
        }

        // 处理发放内容 - 使用sid字段
        if (data.sid) {
          if (_this8.form.type === 4) {
            // 套券类型：等待券包列表加载完成后再设置
            // 注意：券包id是Long类型，sid是String类型，需要类型转换匹配
            _this8.waitForCouponPackages().then(function () {
              // 将sid转换为字符串进行匹配（券包id可能需要转字符串比较）
              var matchedPackage = _this8.couponPackagesList.find(function (pkg) {
                return String(pkg.id) === String(data.sid) || pkg.id === parseInt(data.sid);
              });
              if (matchedPackage) {
                _this8.selectedPackageId = matchedPackage.id;
              } else {
                console.warn('未找到匹配的券包，sid:', data.sid);
              }
            });
          } else if (_this8.form.type === 5) {
            // 单品券类型：等待优惠券列表加载完成后再设置
            // 优惠券typeId通常是Long类型，sid是String，需要转换匹配
            _this8.waitForBonusList().then(function () {
              var matchedCoupon = _this8.bonusList.find(function (coupon) {
                return String(coupon.typeId) === String(data.sid) || coupon.typeId === parseInt(data.sid);
              });
              if (matchedCoupon) {
                _this8.selectedCouponId = matchedCoupon.typeId;
              } else {
                console.warn('未找到匹配的优惠券，sid:', data.sid);
              }
            });
          }
        }
        _this8.loading = false;
      }).catch(function () {
        _this8.loading = false;
      });
    },
    loadUserRankOptions: function () {
      var _loadUserRankOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.userRankOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
                // 只在新建时（没有 id）默认全选所有用户级别
                if (!this.id && this.userRankChecked.length === 0) {
                  this.userRankChecked = this.userRankOptions.map(function (rank) {
                    return rank.id;
                  });
                }
              } else {
                console.error('获取用户级别列表失败:', response.message);
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取用户级别列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadUserRankOptions() {
        return _loadUserRankOptions.apply(this, arguments);
      }
      return loadUserRankOptions;
    }(),
    loadCouponPackages: function () {
      var _loadCouponPackages = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _bonusSend.getCouponPackagesWithItems)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.couponPackagesList = response.data;
              } else {
                this.$message.error(response.message || '加载券包数据失败');
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('加载券包数据失败:', _t3);
              this.$message.error('加载券包数据失败：' + _t3.message);
            case 3:
              _context3.prev = 3;
              // 无论成功或失败，都标记为已加载
              this.couponPackagesLoaded = true;
              return _context3.finish(3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2, 3, 4]]);
      }));
      function loadCouponPackages() {
        return _loadCouponPackages.apply(this, arguments);
      }
      return loadCouponPackages;
    }(),
    waitForCouponPackages: function waitForCouponPackages() {
      var _this9 = this;
      return new Promise(function (resolve) {
        if (_this9.couponPackagesLoaded) {
          resolve();
        } else {
          var checkInterval = setInterval(function () {
            if (_this9.couponPackagesLoaded) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          // 超时保护
          setTimeout(function () {
            clearInterval(checkInterval);
            resolve();
          }, 5000);
        }
      });
    },
    waitForBonusList: function waitForBonusList() {
      var _this0 = this;
      return new Promise(function (resolve) {
        if (_this0.bonusListLoaded) {
          resolve();
        } else {
          var checkInterval = setInterval(function () {
            if (_this0.bonusListLoaded) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          // 超时保护
          setTimeout(function () {
            clearInterval(checkInterval);
            resolve();
          }, 5000);
        }
      });
    },
    loadBonusList: function () {
      var _loadBonusList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _lottery.getBonusList)();
            case 1:
              response = _context4.sent;
              if (response.code === 200 && response.data) {
                this.bonusList = response.data;
              } else {
                this.$message.error(response.message || '加载优惠券列表失败');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('加载优惠券列表失败:', _t4);
              this.$message.error('加载优惠券列表失败：' + _t4.message);
            case 3:
              _context4.prev = 3;
              // 无论成功或失败，都标记为已加载
              this.bonusListLoaded = true;
              return _context4.finish(3);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2, 3, 4]]);
      }));
      function loadBonusList() {
        return _loadBonusList.apply(this, arguments);
      }
      return loadBonusList;
    }(),
    restoreCouponDetailsFromBonus: function restoreCouponDetailsFromBonus() {
      var _this1 = this;
      if (!this.selectedPackage || !this.selectedPackage.items) return;

      // 套券类型：默认全部勾选且禁用
      if (this.form.type === 4) {
        this.selectedPackage.items.forEach(function (item) {
          _this1.$set(item, 'checked', true);
          _this1.$set(item, 'disabled', true);
        });

        // 自动填充价格
        if (this.selectedPackage.oldPrice != null) {
          this.form.marketMoney = this.selectedPackage.oldPrice;
        }
        if (this.selectedPackage.price != null) {
          this.form.money = this.selectedPackage.price;
        }
      }
    },
    handlePackageChange: function handlePackageChange(packageId) {
      var _this10 = this;
      if (!packageId) return;
      var pkg = this.couponPackagesList.find(function (p) {
        return p.id === packageId;
      });
      if (pkg && pkg.items) {
        pkg.items.forEach(function (item, index) {
          // 套券：自动全选
          if (_this10.form.type === 4) {
            _this10.$set(item, 'checked', true);
            _this10.$set(item, 'disabled', true);
            // 套券：只在新建模式（没有 id）时自动填充价格
            if (!_this10.id) {
              if (pkg.oldPrice != null) {
                _this10.form.marketMoney = pkg.oldPrice;
              }
              if (pkg.price != null) {
                _this10.form.money = pkg.price;
              }
            }
          } else {
            // 单品券：只能选一个，默认选第一个
            _this10.$set(item, 'checked', index === 0);
            _this10.$set(item, 'disabled', false);
          }
          _this10.$set(item, 'sendNum', item.sendNum || 0);
          // 初始化特惠单价（确保响应式）
          if (!_this10.itemSpecialUnitPrices.hasOwnProperty(item.id)) {
            _this10.$set(_this10.itemSpecialUnitPrices, item.id, 0);
          }
        });
      }
    },
    // 根据已有的 specialMoney 按比例分配各券明细特惠单价（初始化和手动修改总价时共用）
    redistributeSpecialUnitPrices: function redistributeSpecialUnitPrices() {
      var _this11 = this;
      if (!this.selectedPackage || !this.selectedPackage.items) return;
      if (this.form.type !== 4) return;
      var items = this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
      var totalSpecial = parseFloat(this.form.specialMoney) || 0;
      if (totalSpecial <= 0 || items.length === 0) {
        this.selectedPackage.items.forEach(function (item) {
          _this11.$set(_this11.itemSpecialUnitPrices, item.id, 0);
        });
        return;
      }

      // 按购买价比例分配总价，再除以发券数量得到单价
      var prices = this.itemPurchasePrices;
      var totalPurchase = Object.keys(prices).reduce(function (sum, id) {
        return sum + prices[id];
      }, 0);
      var accumulated = 0;
      items.forEach(function (item, index) {
        var sendNum = parseInt(item.sendNum) || 1;
        var itemTotal;
        if (totalPurchase <= 0) {
          // 无购买价时均分
          itemTotal = index === items.length - 1 ? Math.round((totalSpecial - accumulated) * 100) / 100 : Math.round(totalSpecial / items.length * 100) / 100;
        } else {
          var itemPrice = prices[item.id] || 0;
          if (index === items.length - 1) {
            itemTotal = Math.round((totalSpecial - accumulated) * 100) / 100;
          } else {
            itemTotal = Math.round(totalSpecial * (itemPrice / totalPurchase) * 100) / 100;
          }
        }
        accumulated += itemTotal;
        var unitPrice = Math.round(itemTotal / sendNum * 100) / 100;
        _this11.$set(_this11.itemSpecialUnitPrices, item.id, unitPrice);
      });
    },
    // 用户手动修改总特惠价时，按比例重新分配各券明细单价
    handleSpecialMoneyChange: function handleSpecialMoneyChange() {
      var _this12 = this;
      if (this.form.type === 4 && this.specialPriceConditionMet) {
        this._isRedistributing = true;
        this.redistributeSpecialUnitPrices();
        this.$nextTick(function () {
          _this12._isRedistributing = false;
        });
      }
    },
    handleCouponChange: function handleCouponChange(couponId) {
      // 单品券选择变更时的处理
      console.log('选中的优惠券ID:', couponId);
      // 这里可以添加其他逻辑，比如根据优惠券设置默认价格等
    },
    handleSelectAllItems: function handleSelectAllItems() {
      var _this13 = this;
      if (!this.selectedPackage || !this.selectedPackage.items) return;
      var newCheckedState = !this.isAllItemsSelected;
      this.selectedPackage.items.forEach(function (item) {
        _this13.$set(item, 'checked', newCheckedState);
      });
    },
    handleItemCheckChange: function handleItemCheckChange() {
      var _this14 = this;
      // 单品券只能选一个
      if (this.form.type !== 4 && this.selectedPackage && this.selectedPackage.items) {
        var checkedItems = this.selectedPackage.items.filter(function (item) {
          return item.checked;
        });
        if (checkedItems.length > 1) {
          // 如果选中了多个，只保留最后一个
          this.selectedPackage.items.forEach(function (item) {
            if (item.checked && item !== checkedItems[checkedItems.length - 1]) {
              _this14.$set(item, 'checked', false);
            }
          });
        }
      }
    },
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '代金券',
        2: '折扣券',
        3: '商品券',
        4: '赠品券',
        5: '配送券'
      };
      return typeMap[type] || '未知类型';
    },
    // 格式化价格为两位小数
    formatPrice: function formatPrice(val) {
      var num = parseFloat(val) || 0;
      return num.toFixed(2);
    },
    handleSelectAllUserRanks: function handleSelectAllUserRanks() {
      if (this.isAllUserRanksSelected) {
        this.userRankChecked = [];
      } else {
        this.userRankChecked = this.userRankOptions.map(function (rank) {
          return rank.id;
        });
      }
    },
    validateTimeRange: function validateTimeRange(rule, value, callback) {
      if (!this.timeRange || this.timeRange.length !== 2) {
        callback(new Error('请选择购买时间'));
      } else {
        callback();
      }
    },
    validateMarketMoney: function validateMarketMoney(rule, value, callback) {
      // 套券类型：通过券包自动填充，不需要验证
      if (this.form.type === 4) {
        callback();
      } else {
        // 单品券类型：需要手动输入
        if (!value || value <= 0) {
          callback(new Error('请输入市场价格'));
        } else {
          callback();
        }
      }
    },
    validateMoney: function validateMoney(rule, value, callback) {
      // 套券类型：通过券包自动填充，不需要验证
      if (this.form.type === 4) {
        callback();
      } else {
        // 单品券类型：需要手动输入
        if (!value || value <= 0) {
          callback(new Error('请输入购买价格'));
        } else {
          callback();
        }
      }
    },
    handleSubmit: function handleSubmit() {
      var _this15 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          var checkedItems, finalPrice, formData, details, _t5, _t6, _t7;
          return regeneratorRuntime.wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (valid) {
                  _context5.next = 1;
                  break;
                }
                return _context5.abrupt("return");
              case 1:
                if (!(!_this15.timeRange || _this15.timeRange.length !== 2)) {
                  _context5.next = 2;
                  break;
                }
                _this15.$message.error('请选择购买时间');
                return _context5.abrupt("return");
              case 2:
                if (!(_this15.form.type === 4 && !_this15.selectedPackageId)) {
                  _context5.next = 3;
                  break;
                }
                _this15.$message.error('请选择券包');
                return _context5.abrupt("return");
              case 3:
                if (!(_this15.form.type === 5 && !_this15.selectedCouponId)) {
                  _context5.next = 4;
                  break;
                }
                _this15.$message.error('请选择优惠券');
                return _context5.abrupt("return");
              case 4:
                if (!(_this15.form.type === 4 && _this15.selectedPackage && _this15.selectedPackage.items)) {
                  _context5.next = 5;
                  break;
                }
                checkedItems = _this15.selectedPackage.items.filter(function (item) {
                  return item.checked;
                });
                if (!(checkedItems.length === 0)) {
                  _context5.next = 5;
                  break;
                }
                _this15.$message.error('请至少选择一张券');
                return _context5.abrupt("return");
              case 5:
                if (!(_this15.isEdit && _this15.form.totalNum != null && _this15.originalTotalNum != null)) {
                  _context5.next = 6;
                  break;
                }
                if (!(_this15.form.totalNum < _this15.originalTotalNum)) {
                  _context5.next = 6;
                  break;
                }
                _this15.$message.error('库存只能增加不能减少');
                return _context5.abrupt("return");
              case 6:
                // 验证购买价格是否为0，二次确认
                finalPrice = 0;
                if (_this15.form.type === 4 && _this15.selectedPackage) {
                  // 套券：使用券包的购买价
                  finalPrice = parseFloat(_this15.selectedPackage.price) || 0;
                } else {
                  // 单品券：使用表单的购买价
                  finalPrice = parseFloat(_this15.form.money) || 0;
                }
                if (!(finalPrice === 0)) {
                  _context5.next = 10;
                  break;
                }
                _context5.prev = 7;
                _context5.next = 8;
                return _this15.$confirm('购买价格设置为0将免费发放，确认要继续吗？', '价格警告', {
                  confirmButtonText: '确认免费发放',
                  cancelButtonText: '取消',
                  type: 'warning',
                  distinguishCancelAndClose: true
                });
              case 8:
                _context5.next = 10;
                break;
              case 9:
                _context5.prev = 9;
                _t5 = _context5["catch"](7);
                return _context5.abrupt("return");
              case 10:
                if (_this15.specialPriceConditionMet) {
                  _context5.next = 11;
                  break;
                }
                _this15.form.specialMoney = 0;
                _context5.next = 15;
                break;
              case 11:
                if (!(parseFloat(_this15.form.specialMoney) === 0)) {
                  _context5.next = 15;
                  break;
                }
                _context5.prev = 12;
                _context5.next = 13;
                return _this15.$confirm('当前已启用特惠条件（当日注册/参与过秒杀/产生过消费单）但特惠价格设置为0，确认要继续吗？', '特惠价格确认', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning',
                  distinguishCancelAndClose: true
                });
              case 13:
                _context5.next = 15;
                break;
              case 14:
                _context5.prev = 14;
                _t6 = _context5["catch"](12);
                return _context5.abrupt("return");
              case 15:
                // 处理用户级别
                formData = _objectSpread({}, _this15.form);
                formData.userRank = (0, _toConsumableArray2.default)(_this15.userRankChecked).sort().join(',');

                // 处理时间范围
                if (_this15.timeRange && _this15.timeRange.length === 2) {
                  formData.startTime = _this15.timeRange[0];
                  formData.endTime = _this15.timeRange[1];
                }

                // 处理发放内容 - 使用sid字段
                if (_this15.form.type === 4 && _this15.selectedPackage) {
                  // 套券类型：sid为券包id
                  formData.sid = _this15.selectedPackageId;

                  // 套券类型：使用券包的价格
                  if (_this15.selectedPackage.oldPrice != null) {
                    formData.marketMoney = _this15.selectedPackage.oldPrice;
                  }
                  if (_this15.selectedPackage.price != null) {
                    formData.money = _this15.selectedPackage.price;
                  }

                  // 构建券明细价格列表
                  details = [];
                  _this15.selectedPackage.items.filter(function (item) {
                    return item.checked;
                  }).forEach(function (item) {
                    details.push({
                      itemId: item.id,
                      crmCouponId: item.crmCouponId,
                      specialMoney: _this15.itemSpecialUnitPrices[item.id] || 0
                    });
                  });
                  formData.details = details;
                } else if (_this15.form.type === 5 && _this15.selectedCoupon) {
                  // 单品券类型：sid为优惠券id
                  formData.sid = _this15.selectedCoupon.typeId;
                }

                // 移除不需要的字段
                delete formData.timeRange;

                // 编辑时添加 id
                if (_this15.id) {
                  formData.id = _this15.id;
                }
                _this15.loading = true;
                _context5.prev = 16;
                _context5.next = 17;
                return (0, _secKill.saveSecKill)(formData);
              case 17:
                _this15.$message.success('保存成功');
                _this15.$emit('success');
                _context5.next = 19;
                break;
              case 18:
                _context5.prev = 18;
                _t7 = _context5["catch"](16);
                _this15.$message.error('保存失败');
              case 19:
                _context5.prev = 19;
                _this15.loading = false;
                return _context5.finish(19);
              case 20:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[7, 9], [12, 14], [16, 18, 19, 20]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};